import React, { FC, PropsWithChildren, ReactElement } from "react";
import { cn } from "helpers/style";
import styles from "./Paper.module.scss";

type Props = PropsWithChildren<
  Partial<{
    elevation: 0 | 1;
    withHover: boolean;
  }>
>;

const Paper: FC<Props> = ({
  elevation,
  withHover,
  children,
}: Props): ReactElement => {
  return (
    <div
      className={cn([
        styles.paper,
        styles[`elevation${elevation}`],
        withHover && styles.withHover,
      ])}
    >
      {children}
    </div>
  );
};

export default Paper;
